/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Vuex from 'vuex';
import activity from './modules/activity';
import user from './modules/user';
import getters from './getters';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    activity: activity,
    user: user
  },
  getters: getters
});
export default store;